import productTypes from '../../api/productTypes';
import * as types from '../mutation-types';
import _ from 'lodash';

const state = {
  product_types: [],
  selected: {}
};

const getters = {
  ProductTypes: state => state.product_types,
  SelectedProductType: state => state.selected
};

const actions = {
  getProductTypes({ commit }) {
    productTypes.getProductTypes().then(response => {
      commit(types.SET_PRODUCT_TYPES, response);
    });
  },
  updateProductType({ commit }, { id, updates }) {
    productTypes
      .updateProductType(id, updates)
      .then(response => {
        commit(types.SET_UPDATE_PRODUCT_TYPE, response.data);
        commit(types.SET_SELECTED_PRODUCT_TYPE, response.data.id);
      })
      .catch(error => console.log(error));
  },
  addProductType({ commit }, productType) {
    return new Promise((resolve, reject) => {
      productTypes
        .addProductType(productType)
        .then(response => {
          commit(types.ADD_PRODUCT_TYPE, response.data);
          commit(types.SET_SELECTED_PRODUCT_TYPE, response.data.id);
        })
        .catch(error => reject(error));
    });
  },
  deleteProductType(context, productType) {
    return new Promise((resolve, reject) => {
      productTypes
        .deleteProductType(productType.id)
        .then(() => {
          resolve(true);
        })
        .catch(error => reject(error));
    });
  },
  setSelectedProductType({ commit }, id) {
    commit(types.SET_SELECTED_PRODUCT_TYPE, id);
  }
};

const mutations = {
  [types.SET_PRODUCT_TYPES](state, response) {
    state.product_types = response.data;
  },
  [types.SET_SELECTED_PRODUCT_TYPE](state, id) {
    state.selected = _.find(state.product_types, productType => productType.id === id);
  },
  [types.ADD_PRODUCT_TYPE](state, response) {
    state.product_types.push(response);
  },
  [types.SET_UPDATE_PRODUCT_TYPE](state, response) {
    const record = _.find(state.product_types, productType => productType.id === response.id);
    _.merge(record, response);
  },
  [types.REMOVE_PRODUCT_TYPE](state, id) {
    const index = state.product_types.findIndex(item => item.id === id);
    if (index >= 0) {
      state.product_types.splice(index, 1);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
